import { isThirdPartyTelematicsDeviceType } from './common/deviceTypes';

export const checkoutBaseUrl = import.meta.env.VITE_CHECKOUT_ROUTE;

const GEO_FALLBACK_LEVEL_SWITCH_TIMESTAMP = Date.parse('2026-09-01T00:00:00Z');

export function getCheckoutUrl(deviceType: string | null | undefined, resourceIds: string[]): string {
    const commaSeparatedResources =
        resourceIds.length > 0 && resourceIds.length <= 200 ? resourceIds.join(',') : undefined;
    const resourceIdParam = commaSeparatedResources !== undefined ? `&resourceIds=${commaSeparatedResources}` : '';

    if (isThirdPartyTelematicsDeviceType(deviceType)) {
        return `${checkoutBaseUrl}/?productId=rio-sku00000047&level=34&popup=true${resourceIdParam}`;
    }

    const fallbackLevel = Date.now() >= GEO_FALLBACK_LEVEL_SWITCH_TIMESTAMP ? '14' : '15';
    return `${checkoutBaseUrl}/?productId=rio-sku00000047&level=${fallbackLevel}&popup=true${resourceIdParam}`;
}
